export default "__VITE_ASSET__Cqvmfjb8__"